export default {
    ExpireLoader: {
        expires_in: 'Expira em {expire} segundos',
    },
}